import * as React from "react";
import { Window } from "@stenajs-webui/modal";
import { MissingParamBoundary } from "./MissingParamBoundary";

interface Props {
  customerId?: string;
  headAgreementId?: string;
  isOpen?: boolean;
  onRequestClose?: () => void;
}

export const CreateMultiLegAgreementModal: React.FC<Props> = ({
  isOpen = false,
  onRequestClose,
  ...props
}) => {
  return (
    <Window
      isOpen
      onRequestClose={onRequestClose}
      indent={2}
      width={"100%"}
      headerText="New multi leg agreement"
    >
      <MissingParamBoundary {...props} onRequestClose={onRequestClose} />
    </Window>
  );
};
